<template>
  <div class="setup__btnGroup" :class="{ disabled }">
    <div v-if="showLabel" class="setup__text">
      <slot name="label">
        <span>{{ labelPrefix }}{{ isOn ? labelOn : labelOff }}</span>
      </slot>
    </div>
    <div
      class="setup__outer"
      :class="{ active: isOn }"
      role="switch"
      :aria-checked="isOn.toString()"
      :aria-disabled="disabled.toString()"
      tabindex="0"
      @click="toggle"
      @keydown.enter.space="toggle"
    >
      <div class="setup__inner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SwitchButton",
  props: {
    // v-model 綁定值 (Vue2 使用 value + input)
    value: {
      type: Boolean,
      default: false,
    },
    // 顯示標籤文字: 前綴 + 開啟/關閉
    labelPrefix: {
      type: String,
      default: "",
    },
    labelOn: {
      type: String,
      default: "開啟",
    },
    labelOff: {
      type: String,
      default: "關閉",
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOn() {
      return this.value;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      const next = !this.value;
      this.$emit("input", next);
      this.$emit("change", next);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_mixin.scss";

// 與 SetAstrolabe.vue 中的 setup__btnGroup 保持一致樣式
.setup__btnGroup {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #868686;
  @include mobile {
    font-size: 12px;
  }
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.setup__text {
  margin-right: 16px;
  @include pad {
    margin-right: 8px;
  }
}
.setup__outer {
  height: 37.5px;
  width: 60px;
  border-radius: 100px;
  position: relative;
  border: 2px solid $theme-color-1;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  transition: 0.2s;
  @include pad {
    height: 26px;
    width: 40px;
  }
  &.active {
    background-color: $theme-color-1;
    .setup__inner {
      transform: translate(20px, -50%);
      @include mobile {
        transform: translate(13px, -50%);
      }
    }
  }
  .setup__inner {
    height: 29.5px;
    width: 29.5px;
    border-radius: 50%;
    background-color: #fff;
    border: 2px solid $theme-color-1;
    transition: 0.2s;
    position: absolute;
    top: 50%;
    left: 4px;
    transform: translate(0, -50%);
    @include pad {
      height: 21px;
      width: 21px;
      left: 1px;
    }
  }
}
</style>
